import React from 'react'
import {  useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getPaymentMethodList } from '../../store/slices/general/thunks';
import { Details } from './Details';
import { Header } from './Header';

export const TravelerScreen = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { info } = useSelector((state) => state.traveler);

  useEffect(() => {
    if (!info || !info.id) {
      navigate("/viaje")
    }
  }, [info]);


  useEffect(() => {
    dispatch(getPaymentMethodList())
  }, [])

  return (
    <div>      
      <Header info={info} />    
      <div >
        Nota: Si tienes alguna duda respecto de tus pagos, por favor comunicate al 614 192 2828 o 614 362 3709
      </div>
      <Details info={info} />
    </div>
  )
}
